import React, {useEffect, useState} from "react";

import Table from "../../common/Table";
import calc from "../../../utils/calculation";

const BenefitsList = ({ data }) => {

  const payablesColumns = [
    { path: "id", label: "شماره" },
    { path: "month",      label: "ماه"},
    { path: "year", label: "سال" },
    { path: "present_count", label: "حاضر" },
    { path: "absent_count", label: "غیر حاضر" },
    { path: "holiday_count", label: "رخصت" },
    { path: "salary_per_month", label: "معاش" },
    { path: "absent_cut", label: "کسر غیابت" },
    { path: "salary_tax", label: "مالیه" },
    { path: "amount", label: "قابل پرداخت" },
  ];

  const summary = {
    "present_count": calc.getTotal(data, "present_count"),
    "absent_count": calc.getTotal(data, "absent_count"),
    "holiday_count": calc.getTotal(data, "holiday_count"),
    "salary_per_month": calc.getTotal(data, "salary_per_month"),
    "absent_cut": calc.getTotal(data, "absent_cut"),
    "salary_tax":  calc.getTotal(data, "salary_tax"),
    "amount": calc.getTotal(data, "amount"),
  }


  return (
  <div className="print-table-area">
    <Table
        data={{data, summary}}
        columns={payablesColumns}
    />
  </div>
  );
};

export default BenefitsList;
